export type ImpersonationSource = 'modal' | 'link';

let pendingSource: ImpersonationSource | null = null;

/**
 * Names where the next impersonation start came from. The store carries no
 * such thing, and both the settings modal and the `?impersonation=` link land
 * in it through the same actions, so the link gate marks itself here just
 * before it writes and the tracking hook reads the mark off on the transition.
 */
export const markImpersonationSource = (source: ImpersonationSource): void => {
  pendingSource = source;
};

/** The pending mark, or `modal` — the only other way in. Clears the mark. */
export const consumeImpersonationSource = (): ImpersonationSource => {
  const source = pendingSource ?? 'modal';
  pendingSource = null;
  return source;
};
